module.exports = __webpack_public_path__ + "static/media/start-gray.22a7afc0.svg";